import _ from 'lodash';
import { DEFAULT_LOCALIZATION_CONTEXT } from '../constants';

/**
 * Returns the current available localization context for browser run time environment.
 * @returns {Object} - localization context object
 */
export const getLocalizationContext = () => {
    const localizationContext = _.get(window, 'initialData.LocalizationContext');

    if (!localizationContext) {
        return DEFAULT_LOCALIZATION_CONTEXT;
    }

    return localizationContext;
};

/**
 * Wraps a function and injects dynamically the localization context (browser run time)
 * as the first parameter.
 * @param baseFunc {Function} - the function to wrap
 * @returns {Function} - localizationContext wrapped function
 */
export const withBrowserContext = (baseFunc) => (...args) => {
    const localizationContext = getLocalizationContext();
    return baseFunc(localizationContext, ...args);
};
